import { useTranslation } from 'react-i18next';
import getReportFileName from 'helpers/getReportFileName';
import roles from 'helpers/roles';

import BrandDateSubbrandsReport from './BrandDateSubbrandsReport';

const OverproductionFoodCost = () => {
  const { t } = useTranslation();
  const title = t('reports.reportOverProductionFoodCost');

  return (
    <BrandDateSubbrandsReport
      title={title}
      url="reports/overproduction-food-cost"
      previewXlsxAvailable={true}
      mimeType="application/vnd.ms-excel"
      fileName={getReportFileName(title)}
      role={roles.ROLE_SHOW_REPORT_OVERPRODUCTION_FOOD_COST}
      useDateRange={true}
      useSubBrands={true}
      useBrands={false}
      showMultiplier={false}
      archiveReportNames={['OVERPRODUCTION_FOOD_COST']}
    />
  );
};

export default OverproductionFoodCost;
